// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_jo","advertCardPhoto__image":"c-a_jp"};